<div class="w-full h-full bg-primary-one p-6 flex flex-col gap-8">
  <div class="flex items-center gap-4">
    <div class="w-10 h-10 rounded-xl border-white border-opacity-20 border flex items-center justify-center">
      <img src="/assets/images/beexact-icon.svg" alt="BeExact" class="w-7 h-7">
    </div>

    <div class="flex flex-col flex-grow">
      <h3 class="font-bold text-white mb-0">{{ 'menu.title' | translate }}</h3>
      <span class="text-xs text-white text-opacity-80">{{ ('menu.environment.' + environment) | translate }}</span>
    </div>
  </div>

  <div class="flex-grow min-h-0 flex-col flex gap-2">
    <ng-content></ng-content>

    <div class="flex items-center gap-4 mt-auto">
      <app-navbar-item (click)="logout()" class="flex-grow" title="{{ 'menu.sign-out' | translate }}" icon="/assets/images/icon-sign-out.svg"></app-navbar-item>
      <div class="w-10 h-10 rounded-xl border-white border-opacity-20 border flex items-center justify-center">
        <app-language-selector></app-language-selector>
      </div>
    </div>
  </div>
</div>
